import { Popup, Icon, Table, Button, Label } from 'semantic-ui-react'
import { useAuth } from '../../../hooks';
import { getPermissions } from '../../Common/Permissions';

export function ListadoTiposServicio(props) {
  const {tiposServicio, onDeleteTipoServicio, onEditTipoServicio, pagination, onShowTipoServicio, countPage, mostrarConvenio} = props

  const {auth} = useAuth()
  return (
    <Table size='small' celled className='tabla-servicios'>
    <Table.Header className='color_header_table'>
      <Table.Row>
        <Table.HeaderCell>ID</Table.HeaderCell>
        <Table.HeaderCell>Código</Table.HeaderCell>
        <Table.HeaderCell>Nombre</Table.HeaderCell>
        {mostrarConvenio && <Table.HeaderCell>Convenio</Table.HeaderCell>}
        <Table.HeaderCell>Acciones</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body style={{'borderLeft': '1px solid white'}}>
      {tiposServicio.map((tipoServicio,i)=>{
        return(<Table.Row key={i}>
         <Table.Cell>{tipoServicio?.id}</Table.Cell>
         <Table.Cell>{tipoServicio.codigo}</Table.Cell>
         <Table.Cell>{tipoServicio.nombre}</Table.Cell>
         {mostrarConvenio &&
          <Table.Cell>
            {tipoServicio.es_global ? <Label size='small' basic>Global</Label> : tipoServicio.aseguradora_nombre}
          </Table.Cell>}
         <Acciones auth={auth} tipoServicio={tipoServicio} onShowTipoServicio={onShowTipoServicio} onDeleteTipoServicio={onDeleteTipoServicio} onEditTipoServicio={onEditTipoServicio} />
       </Table.Row>
      )})
      }
      </Table.Body>
      <Table.Footer>
      <Table.Row>
        <Table.HeaderCell colSpan='10'>
        {pagination}
        Total de registros: {countPage}
        </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
  </Table>
  )
}


function Acciones(props){
  const {tipoServicio, onDeleteTipoServicio, onEditTipoServicio, onShowTipoServicio, auth} = props

  return(
    <Table.Cell className='acciones'>
      {getPermissions("view_tiposervicio",auth) &&
    <Popup content='Ver tipo de servicio' trigger={<Button size='mini' icon color="blue" basic onClick={()=>onShowTipoServicio(tipoServicio)}>
    <Icon name='eye' />
  </Button>} />}

      {/* Los tipos globales (A, B, C, 2) son de solo lectura para todos. */}
      {tipoServicio.es_global ? (
        <Popup content='Tipo de servicio global: solo lectura' trigger={<Button size='mini' icon basic disabled>
          <Icon name='lock' />
        </Button>} />
      ) : (
        <>
          {getPermissions("change_tiposervicio",auth) &&
          <Popup content='Editar tipo de servicio' trigger={<Button size='mini' icon basic onClick={()=>onEditTipoServicio(tipoServicio)}>
          <Icon name='pencil' />
        </Button>} />}
          {getPermissions("delete_tiposervicio",auth) &&
          <Popup content='Eliminar tipo de servicio' trigger={<Button size='mini' icon negative basic onClick={()=>onDeleteTipoServicio(tipoServicio)}>
          <Icon name='close' />
        </Button>} />}
        </>
      )}
    </Table.Cell>
  )
}
